<script setup lang="ts">
import { useSelectCancelFutureLessons } from '../../../model/additional-info/support/info-pause-subscription/select-cancel-future-lessons.hook'
import { useSelectContactCustomer } from '../../../model/additional-info/support/info-pause-subscription/select-contact-customer.hook'
import { useSelectPauseDuration } from '../../../model/additional-info/support/info-pause-subscription/select-pause-duration.hook'
import { useSelectPauseReason } from '../../../model/additional-info/support/info-pause-subscription/select-pause-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectCancelFutureLessons from './info-pause-subscription/SelectCancelFutureLessons.vue'
import SelectContactCustomer from './info-pause-subscription/SelectContactCustomer.vue'
import SelectPauseDuration from './info-pause-subscription/SelectPauseDuration.vue'
import SelectPauseReason from './info-pause-subscription/SelectPauseReason.vue'

defineOptions({
  name: 'InfoPauseSubscription',
})

const { isRequired: isRequiredPauseDuration } = useSelectPauseDuration()
const { isRequired: isRequiredPauseReason } = useSelectPauseReason()
const { isRequired: isRequiredCancelFutureLessons } = useSelectCancelFutureLessons()
const { isRequired: isRequiredContactCustomer } = useSelectContactCustomer()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Pause duration"
      :required="isRequiredPauseDuration"
    >
      <SelectPauseDuration />
    </RowTaskInfo>
    <RowTaskInfo
      title="Pause reason"
      :required="isRequiredPauseReason"
    >
      <SelectPauseReason />
    </RowTaskInfo>
    <RowTaskInfo
      title="Cancel future lessons"
      :required="isRequiredCancelFutureLessons"
    >
      <SelectCancelFutureLessons />
    </RowTaskInfo>
    <RowTaskInfo
      title="Contact customer"
      :required="isRequiredContactCustomer"
    >
      <SelectContactCustomer />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
